export const SUPPORTED_LANGUAGES = ['en', 'ru'];
export const DEFAULT_LANGUAGE = 'ru';

export const normalizeLanguage = (value) => {
    if (!value || typeof value !== 'string') {
        return null;
    }
    const normalized = value.toLowerCase().split('-')[0];
    return SUPPORTED_LANGUAGES.includes(normalized) ? normalized : null;
};

export const detectBrowserLanguage = () => {
    if (typeof navigator === 'undefined') {
        return DEFAULT_LANGUAGE;
    }
    const candidates = [
        navigator.language,
        ...(Array.isArray(navigator.languages) ? navigator.languages : []),
    ].filter(Boolean);

    for (const candidate of candidates) {
        const normalized = normalizeLanguage(candidate);
        if (normalized) {
            return normalized;
        }
    }

    return DEFAULT_LANGUAGE;
};

